'use client';

import useIsMobile from '@dapp/multi-lib/ui/shared-hooks/useIsMobile';
import { SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import MultiAssetHeader from 'structure/multi-asset-staking/components/MultiAssetHeader';
import { StakingPoolsActions } from 'structure/multi-asset-staking/components/StakingPoolsActions';
import { StakingProjectsList } from 'structure/multi-asset-staking/components/StakingProjectsList';
import { PoolSelection, ViewTypes } from 'structure/multi-asset-staking/types';

export default function Staking() {
  const { t } = useTranslation('common');
  const showTable = !useIsMobile(1279);
  const [view, setView] = useState<ViewTypes>(ViewTypes.CARD_VIEW);
  const [poolSelection, setPoolSelection] = useState<PoolSelection>(
    PoolSelection.ALL
  );

  const handleView = (newView: SetStateAction<ViewTypes>) => setView(newView);

  useEffect(() => {
    handleView(showTable ? ViewTypes.LIST_VIEW : ViewTypes.CARD_VIEW);
  }, [showTable]);

  const handlePoolSelection = (selection: SetStateAction<PoolSelection>) =>
    setPoolSelection(selection);

  return (
    <BaseLayout>
      <div className='flex flex-col p-8 px-0 max-ngmd:px-2'>
        <MultiAssetHeader title={t('STAKING.STAKING_POOLS')} />
        <StakingPoolsActions
          view={view}
          pool={poolSelection}
          handleView={handleView}
          handlePoolSelection={handlePoolSelection}
        />
        <StakingProjectsList view={view} />
      </div>
    </BaseLayout>
  );
}
